// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getPaymentOverrideReasonById } from 'app/constants/enums/PaymentOverrideReason/main';

/* eslint-disable max-len */
export const ADMIN_MISTAKE = getPaymentOverrideReasonById('adminMistake');
export const FRAUDULENT_BEHAVIOUR = getPaymentOverrideReasonById('fraudulentBehaviour');
export const LEGACY_CANCELLATION_WITH_NOTICE = getPaymentOverrideReasonById('legacyCancellationWithNotice');
export const LEGACY_CANCELLATION_WITHOUT_NOTICE = getPaymentOverrideReasonById('legacyCancellationWithoutNotice');
export const OTHER = getPaymentOverrideReasonById('other');
export const RULE_VIOLATION = getPaymentOverrideReasonById('ruleViolation');
export const STUDENT_ISSUE = getPaymentOverrideReasonById('studentIssue');
export const SYSTEM_ISSUE = getPaymentOverrideReasonById('systemIssue');
export const TEACHER_ABSENCE = getPaymentOverrideReasonById('teacherAbsence');
export const TEACHER_TECHNICAL_ISSUE = getPaymentOverrideReasonById('teacherTechnicalIssue');
export const VERIFIED_TEACHER_REASON = getPaymentOverrideReasonById('verifiedTeacherReason');
/* eslint-enable max-len */
